export default __webpack_public_path__ + "static/media/flash06.3ba31054.png";